import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare } from "@fortawesome/pro-light-svg-icons";
import permissions from "../../mocks/menuPermissions.json";
import { camelCase } from "lodash";
import { Loader } from "../";
import authService from "../../components/api-authorization/AuthorizeService";
const HomeWidgetCard = ({
  isDisabled,
  name,
  count,
  onAddClick,
  isLoading,
  link,
  showAdd,
  imgUrl,
}) => {
  const disabled = isDisabled ? "disabled" : "";
  const [roleName, setRoleName] = useState("VOU");
  useEffect(() => {
    getRole();
  }, []);
  const getRole = async () => {
    setRoleName(await authService.getRole());
  };
  return (
    <Link
      href="javascrip:void(0)"
      to={link}
      className={`home-widget-card d-flex flex-column justify-content-between align-items-center p-1 ${disabled}`}
    >
      <div className={`img-box ${name}`}></div>
      <div className="d-flex flex-row w-100 content-container justify-content-between p-2">
        <div>
          <div className="widget-label">{name}</div>
          {isLoading && <Loader size="sm" />}
          {!isLoading && <div className="widget-count">{count}</div>}
        </div>
        <div>
          {permissions[roleName]["menuItems"][camelCase(name)]?.includes("C") &&
            showAdd && (
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Add {name}</Tooltip>}
              >
                <button className="add-icon" onClick={onAddClick}>
                  <FontAwesomeIcon icon={faPlusSquare} size="lg" />
                </button>
              </OverlayTrigger>
            )}
        </div>
      </div>
    </Link>
  );
};

export default HomeWidgetCard;
